/**
 * L'équipe d'un employé ou d'un chantier, parmi les équipes connues.
 *
 * @param {object[]} equipes les équipes
 * @param {'employe'|'chantier'} sorte ce qu'on cherche
 * @param {number} id son identifiant
 * @returns {object|undefined} l'équipe
 */
export function equipeDe(equipes, sorte, id) {
  const cle = sorte === 'chantier' ? 'chantierIds' : 'employeIds';
  return (equipes || []).find((q) => (q?.[cle] || []).includes(id));
}
